// eslint-disable-next-line import/no-unresolved
import Cookies from 'https://cdn.skypack.dev/js-cookie'

if (!customElements.get('store-selector')) {
  customElements.define(
    'store-selector',
    class StoreSelector extends window.BAO.CustomElement {
      _apiKey = '228e329ebf1c469f8dffae5bb9c8fe03'

      constructor () {
        super()

        if (!this.noCookieSet) return

        this.currentCountry = this.els.country_code.element.value.toLowerCase()

        window.BAO.utils
          .fetchJSON(
            `https://api.ipgeolocation.io/ipgeo?apiKey=${
              this._apiKey
            }&fields=country_code2,country_name`,
            {
              method: 'GET',
            }
          )
          .then(res =>
            this.setupCountrySwitcherModal(
              res.country_code2.toLowerCase(),
              res.country_name
            )
          )
      }

      setupListeners () {
        super.setupListeners()

        this.onSubmitClick = this.onSubmitClick.bind(this)
        this.onLinkClick = this.onLinkClick.bind(this)

        if (this.els?.submit.exists) {
          this.els.submit.elements.forEach(submitEl => {
            this.listeners.add(submitEl, 'click', this.onSubmitClick)
          })
        }

        if (this.els?.dropdown.exists) {
          this.listeners.add(this.els.dropdown_toggle.element, 'click', () => {
            this.dropdown = this.els.dropdown.element.ariaExpanded !== 'true'
          })

          this.els.link.elements.forEach(linkEl => {
            this.listeners.add(linkEl, 'click', this.onLinkClick)
          })
        }
      }

      onSubmitClick (e) {
        e.preventDefault()

        Cookies.set(this.cookieName, 'true', { expires: 730 })

        this.setAttribute('aria-hidden', 'true')

        this.els.form.element.submit()
      }

      onLinkClick (e) {
        this.activeCountry = e.target
        this.dropdown = false
      }

      setupCountrySwitcherModal (countryCode, countryName) {
        this.activeCountry = this.els.link.elements.find(linkEl => {
          return linkEl.dataset.countryCode === countryCode.toLowerCase()
        })

        if (countryCode !== this.currentCountry) {
          this.setAttribute('aria-hidden', 'false')
        } else {
          Cookies.set(this.cookieName, 'true', { expires: 730 })
        }
      }

      get currentCountryList () {
        return this.getAttribute('switcher-country-list')
      }

      get noCookieSet () {
        // eslint-disable-next-line compat/compat
        const searchParams = new URLSearchParams(window.location.search)

        return (
          searchParams.get('storeswitcher') === 'show' ||
          (Cookies.get(this.cookieName) === undefined && !Shopify.designMode)
        )
      }

      get cookieName () {
        return `BAO-store-nite`
      }

      get activeCountry () {
        return this._activeCountry
      }

      set activeCountry (el) {
        this.els.title_selected.element.innerText = el.dataset.countryTitle
        this.els.flag_selected.element.src = el.dataset.countryFlag
        this.els.country_code.element.value = el.dataset.countryCode.toUpperCase()

        this._activeCountry = el
      }

      get dropdown () {
        return this._dropdown
      }

      set dropdown (val) {
        this.els.dropdown.element.ariaExpanded = val

        this._dropdown = val
      }
    }
  )
}
